/**
 * Bring an e-mail address to the one shape we store and compare it in:
 * trimmed and lowercased.
 *
 * Copy-pasting an address out of a mail or a spreadsheet routinely drags a
 * leading or trailing space along. That space is invisible in every UI, but a
 * Firestore `.where('Email','==',…)` is byte-exact — so the invitation written
 * with the space never matches the account created without it, and the person
 * is locked out with no trace of why. See docs/inbox.md Bug #137.
 *
 * Mirrored in functions/utils/normalizeEmail.js — change both.
 *
 * Returns '' (never undefined) for missing input, so callers can keep using ''
 * as the hooks' "nog niet ingevuld"-sentinel.
 * AI-CONTEXT: See docs/pitfalls.md#database-empty-string-is-a-real-stored-value
 *
 * @param {string | null | undefined} email - Raw address as typed, pasted or stored
 * @returns {string} Trimmed, lowercased address, or '' when there is none
 */
const normalizeEmail = (email) => (email || '').trim().toLowerCase()

export default normalizeEmail
